import React from 'react'
import companyLogo from "../src/assets/trip_logo.png";
import {Link} from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faBars } from '@fortawesome/free-solid-svg-icons';
import { useState } from 'react';


const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
      };

    return(
        <>
        
<div class='Logoportion'>
<Link to="/" ><img src={companyLogo} alt='Logo' className='logo'/></Link>

   <div className='hamburger' onClick={toggleMenu}><FontAwesomeIcon icon={faBars} style={{width:'30px' ,height:'30px'}} /></div>

   <nav className={`navbar ${isOpen ? 'active':''}`} >
     <ul class='navbar-list'>
      
      <li><Link to="/" class='link'>Home</Link></li> 
      <li><Link to="/about" class='link'>About us</Link></li>
      <li ><Link to="/services" class='link'>Services</Link></li>
      <li><Link to="/contactus" class='link'>Contact us</Link></li> 

     </ul>
    </nav>
   
   </div>
        </>
    );
}

export default Navbar ;